export let details = [
    {
        id:"1",
        name:"Technology",
        image:"https://previews.123rf.com/images/rawpixel/rawpixel1705/rawpixel170577585/79309769-teachnology-communication-computer-digital-network.jpg"
    },
    {
        id:"2",
        name:"Science",
        image:"https://img.freepik.com/free-vector/science-word-theme_23-2148540555.jpg?w=360"
    },
   
    {
        id:"3",
        name:"Skills",
        image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-lBar3x0-ELIY8dvBYzvZBaUPJa-2Qh8Shg&usqp=CAU"
    },
    {
        id:"4",
        name:"Art",
        image:"https://www.pictureframesexpress.co.uk/blog/wp-content/uploads/2020/05/7-Tips-to-Finding-Art-Inspiration-Header-1024x649.jpg "
    },
    {
        id:"5",
        name:"Food",
        image:" https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR7T6XdIC9qQvDkLd4szhUcm2XR_FGDGexoMg&usqp=CAU"
    },
    {
        id:"6",
        name:"Health",
        image:"https://www.healthkart.com/connect/wp-content/uploads/2021/09/900x500_banner_HK-Connect_How-to-Improve-Heart-Health-_-Points-To-Keep-In-Mind.jpg  "
    },
    {
        id:"7",
        name:"Business",
        image:" https://img.etimg.com/thumb/width-1200,height-900,imgsize-26482,resizemode-1,msid-87959405/news/economy/indicators/business-optimism-in-india-at-near-8-year-high-report.jpg "
    },
    {
        id:"8",
        name:"Music",
        image:" https://cdn.pixabay.com/photo/2015/05/07/11/02/guitar-756326__340.jpg  "
    },
    
]
